import styled from "styled-components";

export const Wrapper = styled.div``;

interface IHeaderProps {
  hasbreadcrumb?: boolean;
}

export const Header = styled.div<IHeaderProps>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 12px 16px;
  gap: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  background-color: ${({ theme }) => theme.colors.surface.surface};

  .mainHeader {
    width: 100%;
    min-height: 20px;
    max-height: 120px;
    overflow-y: scroll;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .iconMenuHome {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      cursor: pointer;
    }
    
    .rowHeader {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
      
      .rowHeaderDiscipline {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;

        .iconLeft {
          color: ${({ hasbreadcrumb, theme }) => hasbreadcrumb
    ? theme.colors.surface.onSurfacePlaceholder
    : theme.colors.surface.onSurfaceVariant} !important;
        }
      }

      &:last-child {
        color: ${({ theme }) => theme.colors.surface.onSurface} !important;
      }

      .iconBreadCrumb {
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
        transform: rotate(180deg);
      }

      .rowHeaderDiscipline {
        cursor: pointer;
      }
    }
  }
`;

export const Main = styled.div`
  width: 100%;
  height: 308px;
  max-height: 308px;
  overflow-y: scroll;

  .rowDisciplinesList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    border-radius: 6px;
    width: 100%;
    height: 48px;
    cursor: pointer;

    &+.rowDisciplinesList {
      margin-top: 4px;
    }

    &:hover {
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`} !important;
    }

    .leftRowDisciplinesList {
      display: flex;
      flex-direction: row;
      align-items: center;

      .disciplineListText {
        margin: 0;
        margin-left: 12px;
        color: ${({ theme }) => theme.colors.surface.onSurface};
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
      }

      .disciplineListTextOpaco {
        color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
      }

      .disciplineListTextSelected {
        color: ${({ theme }) => theme.colors.primary.primary};
      }

      .iconLeftRowDisciplinesList {
        color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder} !important;
      }
    }

    .iconRetroceder {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      transform: rotate(180deg);
    }
  }

  .disabledRowDisciplinesList {
    cursor: not-allowed;
  }

  &::-webkit-scrollbar {
    width: 5px !important;
    height: 174px !important;
    background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .buttonNewFolder {
    height: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 6px;
    padding: 0 12px;
    padding-left: 8px;
    margin-left: 0 !important;
    gap: 4px;

    .iconNewFolder {
      color: ${({ theme }) => theme.colors.secondary.onSecondary} !important;
    }
  }

  .rightButtons {
    display: flex;
    justify-content: flex-end;
    gap: 4px;
    
    .buttonCancel {
      height: 32px;
      border-radius: 6px;
      padding: 0 12px;
      margin-left: 0 !important;
    }
    
    .buttonConfirm {
      height: 32px;
      border-radius: 6px;
      padding: 0 12px;
      margin-left: 0 !important;
    }
  }
`;

export const AlertWrapper = styled.div`
  max-height: 300px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 12px;
  overflow-y: auto;

  .content {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .titleAlertWrapper {
      display: flex;
      flex-direction: column;
      gap: 4px;
  
      .titleAlert {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.surface.onSurface};
      }
    
      .titleAlertBold {
        font-weight: 600;
      }
    }
  
    .descriptionAlertWrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
  
      .descriptionAlertIcon {
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      }
  
      .descriptionAlert {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
      }
  
      .radioButtonsWrap {
  
        .newFileNameOption {
          padding-left: 7px;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          color: ${({theme}) => theme.colors.surface.onSurface};
          word-break: break-all;
          cursor: pointer;
  
          .titleOption {
            color: ${({theme}) => theme.colors.surface.onSurfaceVariant};
          }
        }
      }
    }
  
    .gap {
      gap: 4px;
    }
  }
`;
